/*
 * Copyright (c) 2022.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

const URL = 'http://provalt-site-eleveur-dev.s3-website.eu-central-1.amazonaws.com/';
const API_URL = 'https://api-dev.provalt.fr/';

export const environment = {
  version: '%git-version%',
  releaseStage: 'pre-release',
  production: false,
  url: URL,
  oAuth: {
    url: API_URL + 'oauth/v2/',
    urlToken: API_URL + 'oauth/v2/token',
    clientId: '1_4kuvztg8jkiso4k8o888ko44wckk4swk0g04w4ws0o4occ4ko0',
    client_secret: '4whpqi74ezs4skgo4cgs0o0g800cwcksswck8kgwkccks00co0'
  },
  api: {
    url: API_URL,
    version: 0.2
  }
};
